import React from "react";
import { logout } from "../helpers/ad";
import ResetPassword from "./resetPassword";
import AccountRefs from "./accountRefsApi";
import TimesheetHeadings from "./timesheetHeadingsApi";
import RequestLogin from "./requestLoginApi";

const AccountSettings = ({ tokenStore }) => {
  const token = tokenStore.getToken();
  const user = tokenStore.getUser();
  return (
    <div>
      <h2 className="tw-font-bold tw-text-2xl tw-pb-10">Account Settings</h2>
      {user && user.emails && (
        <p>
          Current User: {user.emails[0]}
          <br />
          <button className="btn tw-mb-10 tw-mt-2 btn-primary" onClick={logout}>
            Logout
          </button>
        </p>
      )}
      <RequestLogin token={token} user={user} />
      <AccountRefs token={token} />
      <TimesheetHeadings token={token} />
      <ResetPassword />
    </div>
  );
};

export default AccountSettings;
